(function() {
    if (!sessionStorage.length) {
        localStorage.setItem('getSessionStorage', Date.now());
    };
    if (window.addEventListener) {
        window.addEventListener('storage', function(event) {
          //  console.log(event)
            if (event.key == 'getSessionStorage') {
                localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
                localStorage.removeItem('sessionStorage');
            } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
                if(event.newValue && event.newValue.length != 0){
                    var data = JSON.parse(event.newValue);

                     for (var key in data) {
                        if(key != 'sysSelect'){
                             sessionStorage.setItem(key, data[key]);
                        }

                    }
                }


            }
        });
    }
})();
  //Function.prototype.bind
if (!Function.prototype.bind) {
    Function.prototype.bind = function(oThis) {
        if (typeof this !== "function") {
            throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
        }
        var aArgs = Array.prototype.slice.call(arguments, 1),
            fToBind = this,
            fNOP = function() {},
            fBound = function() {
                return fToBind.apply(this instanceof fNOP && oThis ? this : oThis,
                    aArgs.concat(Array.prototype.slice.call(arguments)));
            };
        fNOP.prototype = this.prototype;
        fBound.prototype = new fNOP();
        return fBound;
    };
}
if (typeof Object.assign != 'function') {
    Object.assign = function(target) {
        'use strict';
        if (target == null) {
          throw new TypeError('Cannot convert undefined or null to object');
        }

        target = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var source = arguments[index];
          if (source != null) {
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
        }
        return target;
      };
}




// WEBPACK FOOTER //
// ./src/assets/common.js